import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";
import { BaseSearchParam } from "models/base-search-param";

import { Referrer } from "models/referrer/referrer";
import { ReferrerSearchParam } from "models/referrer/referrer-search-param";

export async function GetReferrers(param?: ReferrerSearchParam, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Referrer[]>> {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.referrer_search}${queryString}`;
    return await WebAPIClient.getData<Referrer[]>(apiUrl);
}


export async function CreateReferrer(param: Referrer): Promise<APIResult<Referrer>> {
    return await WebAPIClient.postData<Referrer>(ApiEndPoints.referrer_create, param);
}
export async function UpdateReferrer(param: Referrer): Promise<APIResult<Referrer>> {
    return await WebAPIClient.putData<Referrer>(ApiEndPoints.referrer_update.replace("{id}", (param?.id ?? 0).toString()), param);
}